export {
  isDesktopSpiCapable,
  shouldHandleWindowsFrame,
  desktopSpi,
} from './src/desktop-spi';
